/**
 * @generated SignedSource<<cb0402134aa602de28468e62cd09164e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SearchBarRepo$data = {
  readonly isInOrganization: boolean;
  readonly isOwnerEnterpriseManaged: boolean | null | undefined;
  readonly isWritable: boolean;
  readonly nameWithOwner: string;
  readonly viewerCanPush: boolean;
  readonly viewerCanSeeIssueFields: boolean;
  readonly " $fragmentType": "SearchBarRepo";
};
export type SearchBarRepo$key = {
  readonly " $data"?: SearchBarRepo$data;
  readonly " $fragmentSpreads": FragmentRefs<"SearchBarRepo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SearchBarRepo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isInOrganization",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOwnerEnterpriseManaged",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameWithOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanPush",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanSeeIssueFields",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isWritable",
      "storageKey": null
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "beda44dc1afe707895f6142f7a7498e3";

export default node;
